import { createContext } from 'react'
import { AttributionDetails } from '../components/ApplicationForm/types'

export const AttributionContext = createContext<AttributionDetails>({
  source: 'zuto',
  medium: 'direct',
  campaign: 'none'
})
